<template>
  <div class="roulettes-iframe-container">
    <iframe
      v-if="showIframe"
      ref="iframeRoulettes"
      class="roulettes-iframe"
      :src="iframeSrc"
      width="100%"
      height="100%"
      frameborder="0"
      allowfullscreen
      @error="onError"
      @load="onLoad"
    ></iframe>
    <div v-if="error && message" class="error-message">
      <!-- icon -->
      <i class="fas fa-exclamation-triangle"></i>
      <!-- message -->
      <p>{{ message }}</p>

      <!-- go to home -->
      <a-button type="link" @click="$router.push({ name: 'home' })">
        {{ labels.goToHome }}
      </a-button>
    </div>
  </div>
</template>
<script>
import labels from "@/utils/labels";
export default {
  name: "RoulettesIFrame",
  props: {
    authToken: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      labels: { ...labels.roulettes },
      iframeUrl: process.env.VUE_APP_ROULETTES_URL,
      error: false,
      message: "",
    };
  },
  computed: {
    iframeSrc() {
      if (!this.authToken) {
        return null;
      }
      return `${this.iframeUrl}?user_token=${this.authToken}`;
    },
    showIframe() {
      return !this.error && this.iframeUrl;
    },
  },
  methods: {
    onError() {
      this.error = true;
      this.message = this.labels.errorLoadingIframe;
    },
    onLoad() {
      this.error = false;
      this.message = "";
    },
  },
  watch: {
    authToken: {
      immediate: true,
      handler(value) {
        if (!value) {
          this.error = true;
          this.message = this.labels.noAuthToken;
        } else {
          this.error = false;
          this.message = "";
        }
      },
    },
  },
};
</script>
<style scoped lang="scss">
@import "~@/assets/scss/variable";
.roulettes-iframe-container {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;

  .error-message {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1rem;

    i {
      font-size: 2rem;
      color: var(--danger);
    }

    p {
      font-size: 1.5rem;
      color: var(--danger);
      text-align: center;
    }
  }
}
</style>
